import React, { useState } from 'react'
import './Select.css'
import { arrowDown } from '../../assets/icons'
import StatusChips from '../../common/StatusChips/StatusChips'

const SelectField = ({
  label,
  options = [],
  width,
  containerWidth,
  required,
  value,           // can be ID or full object in edit mode
  onChange,
  placeholder = 'Select...',
  disabled = false,
  subLabel,
  filter,
  statusProp,
  fees,
  row,
  isflex,
  individualStudent,
  flex,
  readOnly = false,
  timetable = false,
  displayKey = 'label',   // ← NEW: helps in edit mode
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const isInteractive = !disabled && !readOnly

  const handleToggle = () => {
    if (isInteractive) {
      setIsOpen((prev) => !prev)
    }
  }

  const handleOptionClick = (option) => {
    if (isInteractive) {
      onChange?.(option.value)   // always pass value (ID) to formik
      setIsOpen(false)
    }
  }

  // Improved display logic for edit mode
  const displayContent = () => {
    if (value == null || value === '') {
      return <span className="placeholder-text">{placeholder}</span>
    }

    if (statusProp) {
      return <StatusChips status={value} />
    }

    if (timetable && typeof value === 'object' && value !== null) {
      return value.section || value.name || value.label || '—'
    }

    // NEW: Better handling for edit mode when value is ID but we want to show label
    const selectedOption = options.find((opt) => 
      opt.value === value || opt.value?.toString() === value?.toString()
    )

    if (selectedOption) {
      return selectedOption.label || selectedOption[displayKey] || value
    }

    // Fallback: if value itself looks like a name (string and not number)
    if (typeof value === 'string' && isNaN(Number(value))) {
      return value
    }

    return value // last resort: show ID
  }

  return (
    <div
      className="custom-select-container"
      style={{
        width: containerWidth || '100%',
        margin: filter || row || isflex ? '0' : '',
        flexDirection: row ? 'row' : 'column',
        display: row || isflex ? 'flex' : '',
        gap: row ? '56px' : '',
        alignItems: individualStudent ? 'flex-start' : row ? 'center' : 'flex-start',
      }}
    >
      <label
        style={{
          width: row ? '156px' : '',
          margin: row || isflex ? '0' : '',
        }}
        className="custom-selectfield-label"
      >
        {label}
        {required && <span className="req">*</span>}
      </label>

      <div
        className={`custom-select 
          ${isOpen ? 'open' : ''} 
          ${disabled ? 'disable-select' : ''} 
          ${readOnly ? 'readonly-select' : ''}`}
        onClick={handleToggle}
        style={{
          width: width || '256px',
          borderRadius: filter ? '12px' : '',
          margin: fees ? '0' : '',
          flex: row || isflex || flex ? '1 0 0' : '',
          cursor: isInteractive ? 'pointer' : 'default',
        }}
      >
        <div className="subnbox">
          {subLabel && <span className="span-txt">{subLabel}</span>}
          {displayContent()}
        </div>

        {isInteractive && (
          <img
            src={arrowDown}
            alt="dropdown"
            className={`select-image ${isOpen ? 'open-img' : ''}`}
          />
        )}
      </div>

      {isOpen && isInteractive && (
        <div className="options-container">
          {options.map((option, index) => (
            <div
              key={index}
              className={`option ${value === option.value || value?.toString() === option.value?.toString() ? 'selected' : ''}`}
              onClick={() => handleOptionClick(option)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default SelectField